import { z } from 'zod';
import type {
  ScheduledProductRestrictionDataImportType,
} from 'contracts/restricted-products/scheduled-data-imports';

const MAX_FILE_SIZE = 1024 * 1024 * 10; // 10 MB
const ACCEPTED_FILE_TYPES = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
const DEFAULT_FILE_ERROR_MESSAGE = 'Selecione um arquivo no formato .xlsx';

export const formSchema = z.object({
  uploadType: z.custom<ScheduledProductRestrictionDataImportType>()
    .refine((value) => !!value, 'Selecione o tipo de arquivo'),
  file: z.instanceof(FileList),
}).superRefine((formData, ctx) => {
  const { file: fileList } = formData;

  if (!(fileList instanceof FileList) || fileList.length === 0) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: DEFAULT_FILE_ERROR_MESSAGE,
      path: ['file'],
    });
  }

  const file = fileList[0];

  if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: DEFAULT_FILE_ERROR_MESSAGE,
      path: ['file'],
    });
  }

  if (file.size > MAX_FILE_SIZE) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Arquivo não pode exceder 10 MB',
      path: ['file'],
    });
  }
});

export type FormSchema = z.infer<typeof formSchema>;
export type UploadType = FormSchema['uploadType'];